module.exports = __webpack_public_path__ + "static/media/demo2.8b08d1ca.jpg";